import * as React from 'react'

import { Box, Icon, SelectOption, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'

import type { GroupType, ViewType } from 'modules/shift_management/store/internal/models/View'

interface Props {
  value: string
  options: SelectOption[]
  onChange: (value: GroupType | ViewType) => void
  readonly?: boolean
}
const Selector = ({ value, options, onChange, readonly = false }: Props) => {
  const [open, toggle] = useToggle(false)
  const selectedOption = options.find((option) => option.value === value)
  const disabled = readonly || options.length === 1
  const background = disabled ? 'grey200' : 'grey000White'

  return (
    <PopoverMenu type="list" onClick={toggle(!open)}>
      <PopoverMenu.Trigger disabled={disabled}>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          background={background}
          cursor={disabled ? 'default' : 'pointer'}
          paddingX="s8"
          paddingY="s4"
        >
          <Box flexDirection="row" alignItems="center" gap="s4">
            <Text size="300">{selectedOption?.label}</Text>
            <Icon.Small icon={open ? 'caret-up' : 'caret-down'} />
          </Box>
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        {options.map(({ label, value }) => (
          <PopoverMenu.TouchableOption key={value} onClick={() => onChange(value)} title={label} />
        ))}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default observer(Selector)
